export const getInvestmentTypes = state => state.static.investmentTypes;
export const getTransactionTypes = state => state.static.transactionTypes;
export const getPropertyTypes = state => state.static.propertyTypes;
export const getDefaultColumns = state => state.static.defaultColumns;
export const getStateOptions = state => state.static.stateOptions;
